import {inject} from "./common";

export function init(): void {
    inject("//s.clickiocdn.com/t/210302/360.js", true, null, "__lxGc__rtr");
    inject("//s.clickiocdn.com/t/common_258.js", true);
}
